import React, { useEffect } from "react";

const MeteorBackground = ({ toggle }) => {
  const amount = 30;

  useEffect(() => {
    const meteor = () => {
      const body = document.querySelector("#meteor-container");

      for (let count = 0; count < amount; count++) {
        const drop = document.createElement("i");
        drop.classList.add("meteor"); // Add a class to the meteor

        drop.id = `meteor-${count}`;

        const size = Math.random() * 5;
        const posX = Math.floor(Math.random() * window.innerWidth);
        const delay = Math.random() * 10;
        const duration = Math.random() * 10;

        drop.style.width = `${0.1 + size}px`;
        drop.style.left = `${window.innerWidth + posX}px`;
        drop.style.top = `${-160}px`;
        drop.style.animationDelay = `${delay}s`;
        drop.style.animationDuration = `${4 + duration}s`;

        body.appendChild(drop);
      }
    };

    meteor();
  }, []);

  useEffect(() => {
    for (let j = 0; j < amount; j++) {
      const drop = document.getElementById(`meteor-${j}`);
      if (drop) {
        const isDarkTheme = localStorage.getItem("theme") === "dark";
        drop.style.background = isDarkTheme
          ? "linear-gradient(transparent, #f5f5f5)"
          : "linear-gradient(transparent, #1b1b1b)";
      }
    }
  }, [toggle]);

  return (
    <div
      id="meteor-container"
      className="absolute top-0 left-0 w-full h-full bg-light dark:bg-dark overflow-hidden -z-10" // Ensure meteors are behind everything
    >
      <style>
        {`
          i.meteor { /* Only target meteor elements */
            position: absolute;
            height: 160px;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            animation: raining 5s linear infinite;
            transform: rotate(45deg);
          }

          @keyframes raining {
            0% {
              transform: translate(-20vw) rotate(45deg);
            }
            100% {
              transform: translate(-150vw, calc(200vh)) rotate(45deg);
            }
          }
        `}
      </style>
    </div>
  );
};

export default MeteorBackground;
